module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-overlay",
    staticStyle: {
      "opacity": "1.09",
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "modal-wrapper showSweetAlert visible",
    staticStyle: {
      "display": "block",
      "margin-top": "-191px"
    },
    attrs: {
      "data-custom-class": "",
      "data-has-cancel-button": "true",
      "data-has-confirm-button": "true",
      "data-allow-outside-click": "false",
      "data-has-done-function": "true",
      "data-animation": "pop",
      "data-timer": "null"
    }
  }, [_c('em', {
    staticClass: "sa-icon sa-info icon-info mb-xl"
  }), _vm._v(" "), _vm._t("header"), _vm._v(" "), _c('p', {
    staticClass: "modal-paragraph"
  }, [_vm._v("\n          " + _vm._s(_vm.message) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "modal-buttons"
  }, [_vm._t("body", [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg btn-accept",
    on: {
      "click": function($event) {
        _vm.closeModal()
      }
    }
  }, [_vm._v("OK")])])])])], 2)], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-593816b6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/Information.vue
// module id = 2155
// module chunks = 1